import { StationeryTemplateCategoryEnum } from '@graphql/generated-base';
import { useCardsRouterContext } from '@apps/card/Card.routes';

/**
 * Where the envelope entry point sends anyone it cannot serve. `getShopPath` keeps the
 * `/<handle>/edit` prefix when there is one, so an admin lands back in their own dashboard rather
 * than in the public shop; `getPublicRootPath` returns a flat `/cards` and would eject them. The
 * target is the same gallery both `Dashboard` and `ShopRouter` fall back to.
 *
 * Its own module so `PublicEnvelopes` can use it without importing the flag-gated route eagerly.
 */
export const useEnvelopeFallbackPath = () => {
  const { getShopPath } = useCardsRouterContext();
  return getShopPath('wedding', StationeryTemplateCategoryEnum.saveTheDate);
};
